export default "__VITE_ASSET__Bd7t_yUp__"